import styled from 'styled-components/macro';
import { COLORS, TYPOGRAPHY } from 'styleguide';
import Content from 'components/ConfirmModal/Content';

const Input = styled.input`
  display: block;
  width: 100%;
  padding: 8px 0;
  box-sizing: border-box;
  border: none;
  border-bottom: 1px solid ${COLORS.line};
  outline: none;
  color: #fff;
  ${TYPOGRAPHY.name}
  background-color: transparent;
  transition: border-color 0.15s ease-out, color 0.15s ease-out;

  &[aria-invalid="true"] {
    border-color: ${COLORS.error};
  }

  &:disabled {
    opacity: 0.4;
  }

  &::placeholder {
    opacity: 0.4;
  }

  /* TODO: вынести в отдельную копоненту */
  ${/* sc-sel */Content} & {
    border-color: ${COLORS.gray20};
  }

  /* для сброса стилей автозаполнения в хроме */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${COLORS.black} inset;
    -webkit-text-fill-color: #fff !important;
  }

  &[type="number"],
  &[type="time"] {
    -moz-appearance: textfield;
    margin: 0;
  }

  &[type="datetime-local"],
  &[type="date"],
  &[type="time"] {
    color: rgba(255, 255, 255, 0.4);
  }

  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button,
  &[type="time"]::-webkit-inner-spin-button,
  &[type="time"]::-webkit-outer-spin-button {
    appearance: none;
  }

  &[type="datetime-local"]:focus,
  &[type="date"]:focus,
  &[type="time"]:focus {
    color: #fff;
  }
`;

export default Input;
